<template>
  <div v-if="isUserAuthenticated()">
    <div style="text-align:center;margin-top:25px;" v-show="isWorkInProgress()">
      <v-progress-circular
          :indeterminate="true"
          :rotate="0"
          :size="128"
          :width="4"
          :value="0"
          color="light-blue"
        >
          <span style="font-size:21px;font-weight:bold;">{{progressPercentage}} %</span>
        </v-progress-circular>
    </div>
    <div v-html="contractHtml"></div>
  </div>
</template>

<script>
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import ModalContract from '@/components/ModalContract.vue'
import APIContract from '@/api/contract'
import APIReport from '@/api/report'
const APIContractService = new APIContract();
const APIReportService = new APIReport();
var axios = require('axios')

export default {
  components:
  {
    TemplateAdminComponent
  },

  mounted() {
    // Hide google recaptcha, cause a printing square that hides the email address at the bottom right.
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        var elem = document.getElementsByClassName("grecaptcha-badge")[0]
        elem.style = "visibility:hidden;";
      }
    }
  },

  data() {
    return {
      contractHtml: "",
      contractCount: 0,
      progressPercentage: 0,
      workInProgress: false
    }
  },

  created(){
    this.initialize()
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated();
    },

    logout() {
      auth.logout()
    },

    isWorkInProgress() {
        return this.workInProgress
    },

    async initialize () {

      var i = 0
      var incrementSize = 100
      this.workInProgress = true

      // Get number of contracts.
      await APIContractService.getCountForPostTransmission().then(response =>  {
          this.contractCount = response.data
        }
      )

      var contractCountModulo = this.contractCount % incrementSize

      // Load contracts html by chunks.
      for (i = 0; i < this.contractCount - incrementSize; i+= incrementSize) {
        await APIReportService.generateContractsHtml(i, incrementSize).then(response =>  {
            this.contractHtml += response.data
          }
        )
        this.progressPercentage = (((i + incrementSize) / this.contractCount) * 100).toFixed(0)
      }

      // Load rest of contracts.
      if (contractCountModulo > 0)
      {
        await APIReportService.generateContractsHtml(i, contractCountModulo).then(response =>  {
            this.contractHtml += response.data

          }
        )
      }

      this.progressPercentage = 100
      this.workInProgress = false
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/Contracts.vue